import { VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const ProviderInvoiceFormTotalsConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "money",
                        "name": "subtotal",
                        "label": "Subtotal",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 4
                        },
                        "sizing": {
                            "sm": 8
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "descuento",
                        "label": "Descuento",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 4
                        },
                        "sizing": {
                            "sm": 8
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "impuestos",
                        "label": "Impuestos",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 4
                        },
                        "sizing": {
                            "sm": 8
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "money",
                        "name": "total",
                        "label": "Total",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 4
                        },
                        "sizing": {
                            "sm": 8
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
            ]
        }
    ],
};


export default ProviderInvoiceFormTotalsConfig;